<div class="control single-option-chooser" [ngSwitch]="displayStyle">
  <mat-select *ngSwitchCase="'DropDown'" [(ngModel)]="selectedValue"
      (change)="selectedValueChange.emit($event.value)">
    <mat-option *ngFor="let option of options; trackBy: trackByLabel"
                [value]="option.value">
      {{option.label}}
    </mat-option>
  </mat-select>
  <mat-radio-group *ngSwitchCase="'RadioButton'"
                   (change)="selectedValueChange.emit($event.value)"
                   [value]="selectedValue">
    <mat-radio-button *ngFor="let option of options; trackBy: trackByLabel"
                      [value]="option.value">
      {{option.label}}
    </mat-radio-button>
  </mat-radio-group>
</div>



// WEBPACK FOOTER //
// ./src/app/controls/single-option-chooser/single-option-chooser.component.html